import styled from '@emotion/styled';
import { createElement } from 'react';

import { flexibleLayoutContainer } from '../../styleUtility/flexibleLayout';

interface Props {
  visible?: boolean;
  className?: string;
}

const SigningInIndicatorScreen = ({ visible = false, className }: Props) => (
  <Root visible={visible} className={className}>
    <Indicator visible={visible} />
  </Root>
);

interface StyleProps {
  visible: boolean;
}

const Root = styled.div<StyleProps>(({ visible }: { visible: boolean }) => ({
  ...flexibleLayoutContainer({
    alignItems: 'center',
    justifyContent: 'center',
  }),
  background: '#fff',
  opacity: visible ? 1 : 0,
  visibility: visible ? 'visible' : 'hidden',
  transition: `opacity 300ms ease-in-out 0ms,
               visibility 0ms linear ${visible ? 0 : 300}ms`,
}));

const Indicator = styled.div<StyleProps>(({ visible }: { visible: boolean }) => ({
  width: 64,
  height: 64,
  opacity: visible ? 1 : 0,
  backgroundImage: 'url("/assets/spinner.gif")',
  backgroundSize: 'cover',
}));

export default SigningInIndicatorScreen;
